<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="2 2 12 12"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="3"
    y="3"
    width="4"
    height="4"
    rx="1"
    fill="currentColor"
  />
  <rect
    x="3"
    y="9"
    width="4"
    height="4"
    rx="1"
    fill="currentColor"
  />
  <rect
    x="9"
    y="3"
    width="4"
    height="4"
    rx="1"
    fill="currentColor"
  />
  <rect
    x="9"
    y="9"
    width="4"
    height="4"
    rx="1"
    fill="currentColor"
  />
</svg>
